import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Page, MaskedLines, Reveal } from '../components/motion';
import { useSEO } from '../hooks/useSEO';

export default function NotFound() {
  useSEO('Page Not Found', 'The page you are looking for could not be found.');
  return (
    <Page>
      <section className="min-h-[70vh] flex flex-col justify-center max-w-[1440px] mx-auto px-6 lg:px-12 pt-32">
        <Reveal y={14} className="mb-6">
          <p className="text-xs uppercase tracking-[0.3em] text-accent">Error 404</p>
        </Reveal>
        <MaskedLines
          lines={['This page is', 'off the plan.']}
          lineClassName="font-display text-5xl sm:text-7xl font-semibold uppercase tracking-tight leading-[0.95]"
        />
        <Reveal delay={0.3} className="mt-10">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center gap-3 border border-white/30 text-white font-display font-medium uppercase tracking-wide px-8 py-4 text-sm transition-colors duration-300 hover:border-accent hover:text-accent"
          >
            <ArrowLeft size={16} /> Back home
          </Link>
        </Reveal>
      </section>
    </Page>
  );
}
